"use strict";

angular.module("customer")
.controller("GoodsTransferListController", function(
    $scope, $state, $stateParams, StateExtensionService, GoodsTransferService, UserCustomerService
) {
    var _this = this;
    $scope.pagination = {};
    $scope.params = angular.extend({}, $stateParams);

    $scope.$on("listingFilterUpdated", function(event, filters) {
        $scope.pagination.current_page = 1;
        StateExtensionService.updateUrlParams(filters);
        angular.extend($scope.params, filters);
        _this.fetch();
    });

    this.onPageChanged = function() {
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        this.fetch();
    };

    this.fetch = function() {
        GoodsTransferService.query($scope.params).$promise
        .then(function onSuccess(data) {
            $scope.pagination = data.pagination;
            $scope.goodsTransfers = data.results;
            StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
        });
    };

    this.seeDetails = function(id) {
        $state.go("goodsTransferDetails", {id: id});
    };

    UserCustomerService.release().then(function onSuccess(user) {
        _this.fetch();
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/goods-transfer/goods-transfer-list.controller.js
// module id = 957
// module chunks = 0